import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuShowDialogButtonProps = Omit<Partial<ContextMenuButtonProps>, 'onClick'> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuShowDialogButton: React.FC<ContextMenuShowDialogButtonProps> = ({
  onClick,
}) => {
  const translate = useTypedTranslate();

  const { onCloseMenu } = useContextMenuContext();
  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<VisibilityIcon fontSize="small" />}
      label={translate('app.buttons.show')}
      onClick={handleClick}
    />
  );
};
